import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LoginPage from "../pages/login/page";
import LibraryGuard from "../pages/library/LibraryGuard";
import AccountPage from "../pages/account/page";
import AdminGuard from "../pages/admin/AdminGuard";
import AdminDashboard from "../pages/admin/dashboard/page";
import AgentsPage from "../pages/admin/agents/page";
import AgentEditPage from "../pages/admin/agents/edit/page";
import AgentActivityPage from "../pages/admin/agents/activity/page";
import AgentCreatePage from "../pages/admin/agents/create/page";
import MaterialsAdminPage from "../pages/admin/materials/page";
import MaterialDetailPage from "../pages/admin/materials/detail/page";
import MaterialUploadPage from "../pages/admin/materials/upload/page";
import MaterialEditPage from "../pages/admin/materials/edit/page";
import FeedbackAdminPage from "../pages/admin/feedback/page";
import ActivityLogsPage from "../pages/admin/activity-logs/page";
import PermissionsPage from "../pages/admin/permissions/page";
import WatermarkPage from "../pages/admin/watermark/page";
import ManualPage from "../pages/admin/manual/page";
import PrdPage from "../pages/admin/prd/page";

const routes: RouteObject[] = [
  { path: "/", element: <Navigate to="/login" replace /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/library", element: <LibraryGuard /> },
  { path: "/account", element: <AccountPage /> },
  {
    path: "/admin",
    element: <AdminGuard />,
    children: [
      { index: true, element: <AdminDashboard /> },
      { path: "agents", element: <AgentsPage /> },
      { path: "agents/create", element: <AgentCreatePage /> },
      { path: "agents/:id/edit", element: <AgentEditPage /> },
      { path: "agents/:id/activity", element: <AgentActivityPage /> },
      { path: "materials", element: <MaterialsAdminPage /> },
      { path: "materials/upload", element: <MaterialUploadPage /> },
      { path: "materials/:id", element: <MaterialDetailPage /> },
      { path: "materials/:id/edit", element: <MaterialEditPage /> },
      { path: "feedback", element: <FeedbackAdminPage /> },
      { path: "activity-logs", element: <ActivityLogsPage /> },
      { path: "permissions", element: <PermissionsPage /> },
      { path: "analytics", element: <Navigate to="/admin" replace /> },
      { path: "watermark", element: <WatermarkPage /> },
      { path: "manual", element: <ManualPage /> },
      { path: "prd", element: <PrdPage /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;